import { mapState } from 'vuex';

export default {
    name: 'preloader',
    props: {
    },
}